import { CreditCard } from '@phosphor-icons/react';

export default CreditCard;
